import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

/**
 * Who a template or signature can be shared with (#955): the caller's org members
 * (`GET /api/organizations/members`: user_id, name, email) and the org's groups
 * (`GET /api/organizations/groups`: group_id, name only). Both routes are open to
 * every signed-in member and scoped to the caller's org server-side.
 *
 * Plain axios rather than react-query so the Campaign Builder's template panel,
 * which mounts outside any query-dependent test harness, keeps working unchanged.
 * A failed fetch leaves that list empty; the picker then says so.
 *
 * @param {boolean} enabled fetch only while the picker can be shown
 * @returns {{ members: Array, groups: Array }}
 */
export default function useShareTargets(enabled = true) {
    const { getAuthHeader } = useAuth();
    const [members, setMembers] = useState([]);
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;
        const headers = getAuthHeader();
        const load = async (path, set) => {
            try {
                const res = await axios.get(`${API}${path}`, { headers });
                if (!cancelled) set(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error(`Failed to load ${path}`, err);
            }
        };
        load('/organizations/members', setMembers);
        load('/organizations/groups', setGroups);
        return () => { cancelled = true; };
    // getAuthHeader is a fresh function each render; fetch once per open.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled]);

    return { members, groups };
}
